import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=32ce6e81&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"
import style0 from "./orderView.vue?vue&type=style&index=0&id=32ce6e81&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce6e81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ce6e81')) {
      api.createRecord('32ce6e81', component.options)
    } else {
      api.reload('32ce6e81', component.options)
    }
    module.hot.accept("./orderView.vue?vue&type=template&id=32ce6e81&scoped=true", function () {
      api.rerender('32ce6e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/siteinfo/orderView/orderView.vue"
export default component.exports